import { LoopLogoBadge } from './LoopLogoBadge';

export const NativeItemIndicator = ({ externalKey }: { externalKey?: string | null }) => {
  const isExternalItem = !!externalKey;

  if (isExternalItem) {
    return null;
  }

  return (
    <span className="flex-none text-icon-default" data-testid="native-item-indicator">
      <LoopLogoBadge />
    </span>
  );
};
